module.exports = __webpack_public_path__ + "54110ca906bad8e533e26b01953fee5a.png";